import React, { Context, useContext } from "react";
import { HistoryState } from "@uidotdev/usehooks";

export const useHistoryContext = <S>(context: Context<HistoryState<S>>): HistoryState<S> => {
  return useContext<HistoryState<S>>(context);
};
